import React, { useState, useRef } from 'react';
import { editUser } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function ProfileDetails({ user }) {
  const [name, setName] = useState(user.name);
  const [avatar, setAvatar] = useState(user.image || null); // Assuming image is stored in user object
  const [loading, setLoading] = useState(false);
  debugger
  const fileInputRef = useRef(null);

  // 1. Image Compression Logic (Target < 20KB)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        // Resize to a standard small avatar size (e.g., 128x128)
        const size = 128; 
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, size, size);

        // Quality adjustment loop to stay under 20KB
        let quality = 0.7;
        let base64String = canvas.toDataURL('image/jpeg', quality);
        
        // base64 length is approx 1.33 times the actual byte size
        // 20KB is roughly 27,000 characters in base64
        while (base64String.length > 27000 && quality > 0.1) {
          quality -= 0.1;
          base64String = canvas.toDataURL('image/jpeg', quality);
        }

        setAvatar(base64String);
        console.log("Compressed size:", Math.round(base64String.length / 1024), "KB");
      };
    };
  };

  // 2. Handle Save Changes
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      user_id: user.id,
      name: name,
      image: avatar // Sending the compressed base64 string
    };

    try {
      const res = await editUser(payload);
      if (res.status === 200) {
        // Update Local Storage so the UI reflects changes after refresh
        const session = getStoredUser();
        session.data.name = name;
        session.data.image = avatar;
        localStorage.setItem('user', JSON.stringify(session));
        
        Swal.fire("Profile updated successfully!");
      }
    } catch (err) {
      Swal.fire("Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h5 className="fw-bold mb-1">Personal Information</h5>
      <p className="text-muted small mb-4">Update your photo and personal details here.</p>
      
      <div className="d-flex align-items-center mb-4 pb-4 border-bottom">
        {/* Avatar Display */}
        <div className="shadow-sm rounded-circle overflow-hidden border" style={{ width: '64px', height: '64px' }}>
          {avatar ? (
            <img src={avatar} alt="Profile" className="w-100 h-100 object-fit-cover" />
          ) : (
            <div className="bg-primary text-white w-100 h-100 d-flex align-items-center justify-content-center fw-bold" style={{ fontSize: '1.5rem' }}>
              {name?.charAt(0)}
            </div>
          )}
        </div>

        <div className="ms-3">
          <input 
            type="file" 
            ref={fileInputRef} 
            onChange={handleFileChange} 
            accept="image/*" 
            className="d-none" 
          />
          <button 
            type="button" 
            className="btn btn-sm btn-outline-primary rounded-3 me-2"
            onClick={() => fileInputRef.current.click()}
          >
            Change Avatar
          </button>
          <button 
            type="button" 
            className="btn btn-sm btn-link text-danger text-decoration-none"
            onClick={() => setAvatar(null)}
          >
            Remove
          </button>
        </div>
      </div>

      <form className="row g-3" onSubmit={handleSave}>
        <div className="col-md-6">
          <label className="form-label small fw-bold">Full Name</label>
          <input 
            type="text" 
            className="form-control rounded-3" 
            value={name} 
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label small fw-bold">Email Address</label>
          <input type="email" className="form-control rounded-3" defaultValue={user.email} disabled />
          <small className="text-muted">Email cannot be changed.</small>
        </div>
        <div className="col-12 mt-4">
          <button className="btn btn-primary px-4 rounded-3 shadow-sm" disabled={loading}>
            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-save me-2"></i>}
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}